import { calculateAge } from "@/domain/calculateAge";

export function needsGuardian(dob: string | null | undefined): boolean {
  if (!dob) {
    return false;
  }
  const age = calculateAge(dob);
  return age < 18;
}
